<template>
  <el-dialog class="info-dialog" v-on="$listeners" v-bind="$attrs" width="500px">
    <!-- 对话框头部 -->
    <div class="dialog-header" slot="title">
      <span class="dialog-title">认领信息</span>
      <span class="dialog-title__tip">该商家信息已被认领或信息在审核中</span>
    </div>

    <!-- 认领信息 -->
    <dl class="claim-item">
      <dt class="claim-item__label">认领时间</dt>
      <dd class="claim-item__content">{{ claimAt | timeFormat }}</dd>
    </dl>
    <dl class="claim-item">
      <dt class="claim-item__label">认领人</dt>
      <dd class="claim-item__content">{{ claimName }}</dd>
    </dl>
    <div class="claim-item">
      <div class="claim-item__label">认领说明</div>
      <div class="claim-item__content">{{ claimReason }}</div>
    </div>

    <el-divider></el-divider>

    <div class="dialog-help">
      <div class="dialog-help__left">
        <YorkbbsImage width="90px" height="90px"></YorkbbsImage>
        <div class="tip">扫一扫 加微信</div>
      </div>

      <div class="dialog-help__right">
        <div class="question">我是商家所有者？如有疑问，可联系客服</div>
        <div class="tel">电话：416-980-6970</div>
        <div class="wechat">微信号：{{ wechatId }}</div>
        <div class="copy">
          <el-button v-clipboard:copy="wechatId" v-clipboard:success="handleCopySuccess">
            复制微信号
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'DialogInfo',
  props: {
    data: {
      required: true,
    },
  },

  data() {
    return {
      wechatId: 'YorkbbsAD',
      loading: false,
      post: null,
    };
  },
  computed: {
    claimAt() {
      return this.data && this.data.property.claimAt;
    },
    claimName() {
      return this.data && this.data.property.claimName;
    },
    claimReason() {
      return this.data && this.data.property.claimReason;
    },
  },
  methods: {
    // 复制成功
    handleCopySuccess() {
      this.$success('复制成功');
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-header {
  line-height: 28px;
}
.dialog-title {
  font-size: 20px;
  font-weight: 500;
}
.dialog-title__tip {
  font-size: 12px;
  color: var(--text-color-3);
  margin-left: 10px;
}

.claim-item {
  display: flex;
  line-height: 24px;
  &:not(:first-child) {
    margin-top: 20px;
  }
}
.claim-item__label {
  width: 88px;
  font-size: 16px;
  color: var(--text-color-3);
}
.claim-item__content {
  flex: 1;
  font-size: 16px;
  font-weight: 500;
}

.dialog-help {
  display: flex;
}

.dialog-help__left {
  .tip {
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    color: var(--text-color-3);
  }
}

.dialog-help__right {
  flex: 1;
  margin-left: 16px;

  font-size: 14px;
  line-height: 22px;
  color: var(--text-color-3);

  .tel,
  .wechat {
    padding-top: 5px;
  }

  .copy {
    padding-top: 10px;
    padding-left: 30px;
  }

  .el-button {
    height: 20px;
    padding: 0 5px;
    font-size: 12px;
  }
}

.info-dialog {
  ::v-deep {
    .el-dialog {
      border-radius: 10px;
    }
    .el-dialog__header {
      padding: 24px 30px;
    }
    .el-dialog__body {
      padding: 6px 30px 30px;
    }
    .el-divider {
      margin: 20px 0;
    }
  }
}
</style>
